var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.loading && !_vm.error)?_vm._t("default"):(_vm.error)?_c('SidebarErrorV2',{attrs:{"section-title":_vm.sectionTitle,"error-title":_vm.errorTitle,"error-description":_vm.errorDescription,"icon":"ic_alert_error"},on:{"retry":_vm.refresh}}):_c('SidebarLoader')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }